import { AxiosResponse } from "axios";
import axiosInstanceHubstripe from "./baseHubstripe";
import { Invoice } from "../shared/types/invoice.type";

export class Hubstripe {

    static getCompanyFromCustomerId(customerId: string) {
        return axiosInstanceHubstripe.get('getCompanyFromCustomerId?customerId='.concat(customerId ?? ''))
    }

    static getDealsForCompanyId(companyId: string) {
        return axiosInstanceHubstripe.get('getDealsForCompanyId?companyId='.concat(companyId ?? ''))
    }

    static getSubscriptionsFromCustomerId(customerId: string) {
        return axiosInstanceHubstripe.get('getSubscriptionsFromCustomerId?customerId='.concat(customerId ?? ''))
    }

    static getInvoicesFromCustomerId(customerId: string): Promise<AxiosResponse<{ invoices: Invoice[], pieces: [] }>> {
        return axiosInstanceHubstripe.get('getInvoicesFromCustomerId?customerId='.concat(customerId ?? ''))
    }

    static getCreditNotesFromCustomerId(customerId: string) {
        return axiosInstanceHubstripe.get('getCreditNotesFromCustomerId?customerId='.concat(customerId ?? ''))
    }

    static getCustomerFromCustomerId(customerId: string) {
        return axiosInstanceHubstripe.get('getCustomerFromCustomerId?customerId='.concat(customerId ?? ''))
    }

    static getPaymentMethodsFromCustomerId(customerId: string) {
        return axiosInstanceHubstripe.get('getPaymentMethodsFromCustomerId?customerId='.concat(customerId ?? ''))
    }

    static updatePaymentMethodForCustomerId(data: { customerId: string, paymentMethodId: string }) {
        return axiosInstanceHubstripe.post('updatePaymentMethodForCustomerId', data)
    }

    static deletePaymentMethodForCustomerId(data: { customerId: string, paymentMethodId: string }) {
        return axiosInstanceHubstripe.post('deletePaymentMethodForCustomerId', data)
    }

    static getCreateSetupIntent(customerId: string): Promise<AxiosResponse<{ id: string, sclient: string }>> {
        return axiosInstanceHubstripe.get(`getCreateSetupIntent?customerId=${customerId}`)
    }

}